module.exports = __webpack_public_path__ + "img/icons-fill-field-sapphire.d8c97d1e.svg";